<template>
  <div class="footerContainer">
    <div class="borderBg"></div>
    <section>
      <div class="container">
        <div class="clearfix main">
          <div class="cdInfo fl clearfix">
            <ul class="cduBox fl">
              <li class="title clearfix">
                <span class="fl">成都</span>
                <span class="fr">CHENGDU</span>
              </li>
              <li>地址：成都市锦江区三色路38号成都传媒大厦B座2楼</li>
              <li>电话：028-83106127 / 028-81135027</li>
              <li>客服QQ：3127809168 </li>
            </ul>
            <ul class="bjInfo fl">
              <li class="title clearfix">
                <span class="fl">北京</span>
                <span class="fr">BEIJING</span>
              </li>
              <li>地址：中关村南大街33号北区502室</li>
              <li>电话：010-88544791</li>
              <!-- <li>邮箱：46282115623@126.com</li> -->
            </ul>
          </div>
          <div class="fr code">
            <img src="@/assets/images/news/code.jpg" alt="" />
          </div>
        </div> 
        <p>
          <span>网络文化经营许可证：川网文【2020】3977-821号</span>
          <span>增值电信业务经营许可证：川B2-20220352</span>
          <span>艺术品经营单位备案证明：510104180005</span>
        </p>
        <p style="margin-top: 18px;">
          <a  href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">蜀ICP备10025017号-1</a>
          <span>Copyright © 2022 成都文化产权交易所有限公司 All Rights Reserved</span>
        </p>
        
      </div>
    </section>
  </div>
</template>

<script>

export default {
  props:[]
}
</script>

<style lang="less" scoped>
    .footerContainer{
      color: #fff;
      font-size: 12px;
      min-width: 1200px;
      section{
        background-color: #880c23;
        padding-bottom: 27px;
        p{
          text-align: center;
          margin-top: 38px;
          line-height: 12px;
          span,a{
            margin-right: 40px;
          }
          span:last-child{margin-right: 0;}
        }
        .main{
          .code{
            width: 18%;
            text-align: right;
            img{
                margin-top: 40px;
                height: 142px;
                width: auto;
            }
          }
          .cdInfo{
            // padding-right: 80px;
            width: 82%;
            .cduBox{
              width: 50%;
            }
            .bjInfo{
              width: 50%;
              padding-left: 90px;
            }
            ul{
              padding-top: 30px;
              li{
                line-height: 12px;
                margin-bottom: 20px;
              }
              .title{
                border-bottom: 1px solid #fff;
                font-size: 20px;
                padding-bottom: 10px;
                margin-bottom: 28px;
                line-height: 20px;
              }
            }
          }
        }
      }
      .borderBg{
        background-image: url("../../assets/images/news/border.png");
        background-repeat:repeat-x;
        height: 22px;
      }
      .borderBg{
        content: "";
        display: block;
        height: 48px;
        width: 100%;
        background-color: #750c1e;
      }
    }
</style>



// WEBPACK FOOTER //
// src/layout/components/PublicFooter.vue